import React, { Component } from "react";
import TitleBar from "../_common/TitleBar";

class About extends Component {
  render() {
    return (
      <React.Fragment>
        <TitleBar titleText={"About"} />
        <div className="card m-2">
          <div className="card-body p-3">
            <h3>About ProDMS</h3>
            <hr className="my-2" />
            <p>
              <h5>Help &amp; Support</h5>
              <b>User Guides - </b>
              <a href="https://des.onramp.dot.ca.gov/prodms-guides-and-manuals" target="_blank" rel="noopener noreferrer"> https://des.onramp.dot.ca.gov/prodms-guides-and-manuals</a>
            </p>
            <h5><b>Development Team</b></h5>
            John Zehnder - Lead, Software Architect <br/>
            Adrian Cortez - Specifications, Training, and Customer Support <br/>
            Dustin Helliwell - Quality Assurance & Customer Support <br/>
            Josh Runnion - Specifications & HQ Support <br/>
            Daisy Gee - Presentation & Documentation <br/>
            Loc Nguyen - Lead Developer <br/>
            Christian Sanford - Software Developer <br/>
            <br/>
            <h5><b>Past Members</b></h5>
            Jonathan Yeo, Dave Keim, Sarah Rusby, John Addor, Dan Chapa, Richard Joludow, Linh Do, John Addor, Dan Chapa, Lily Chang, Richard Joludow, Elpidio Perez
            <br/>
            <br/>
            <p>
              <h5>Privacy Statement</h5>
            </p>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default About;
